import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

const config = {
    apiKey: "AIzaSyBY5MxJMIhDJ0Nf2jEk9fYwcu7IvpbL19w",
    authDomain: "electricacaporale-4cd50.firebaseapp.com",
    databaseURL: "https://electricacaporale-4cd50.firebaseio.com",
    projectId: "electricacaporale-4cd50",
    storageBucket: "electricacaporale-4cd50.appspot.com",
    messagingSenderId: "381386128818"
};

const app = firebase.initializeApp(config)
firebase.firestore()
      .enablePersistence({ synchronizeTabs: true })
      .catch(err => console.error(err))


export const database = firebase.firestore()

export const auth = firebase.auth()

export const storage = firebase.storage()
